import { useEffect, useState } from "react";
import calculateTime from "utils/calculateTime";
import { getRoomLogo, getDefaultRoomLogo } from "utils/getRoomLogo";
import { loadFallbackImage } from "utils/loadFallbackImages";
import "./index.css";

function GeneralTeamBoard({ data }) {
  const [time, setTime] = useState("");
  const [roomLogo, setRoomLogo] = useState(null);
  const [fallback] = useState(loadFallbackImage().default);

  useEffect(() => {
    const timeString = calculateTime(data.score);
    setTime(timeString);

    let img =
      getRoomLogo(data.room_name.toUpperCase(), data.location) ||
      getDefaultRoomLogo(data.room_name.toUpperCase()) ||
      loadFallbackImage();
    img && setRoomLogo(img);
  }, [data]);

  return (
    <div className="gb-team-card">
      <div className="gb-card-header">
        <img src={roomLogo || fallback} alt={`${data.room_name} logo`} />
      </div>
      <div className="gb-team-name">{data.team_name.toUpperCase()}</div>
      <div className="gb-escape-time">{time}</div>
    </div>
  );
}

export default GeneralTeamBoard;
